<template>
    <BreadCrumb PageTitle="Ajouter une validation task" />
     <AddModalValidationTask/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddModalValidationTask from "@/components/ValidationTasks/AddModalValidationTask.vue";
  
    export default defineComponent({
      name: "AddValidationTaskPage",
      components: {
        BreadCrumb,
        AddModalValidationTask,
      },
    });
  </script>